import { SairService } from './sair.service';
import { Http } from '@angular/http';
import { Injectable } from '@angular/core';

@Injectable()
export class TokenService {

  constructor(private http: Http, private sairService:SairService) { }


   public revogarToken(urlDestino) {
      this.http.get("central/revoketoken").subscribe(res => this.sairService.sair(urlDestino));
  }

}



// WEBPACK FOOTER //
// C:/Disco D/Projetos/central-cliente/src/app/angular-base-ui/token.service.ts